import type { IContainer } from '../../interface/container';
import type { IMediaCacheController } from '../interface/cache';
import cacheImpl from './cache';

function bind(container: IContainer): IMediaCacheController {
    return cacheImpl();
}

export default bind;
